/*
 * 文件EN: behaviorScore.js,
 * 文件CN: 行为评分,
 * 创建时间: Tuesday, 12th May 2020 3:41:58 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
import request from '@/plugins/http';


/**
 * @desc 列表获取
 * @method GET
 * @param { 参数说明
    * "amountTotal": 0,
	* "bankCode": "",
	* "cycleNo": "",
	* "ficoscore": 0,
	* "ficoscoreLast": 0,
	* "merName": "",
	* "merNo": "",
	* "orgName": "",
	* "quota": 0
    * } 
    */
export const getListData = params => {
	return request.get('/behaviorScore/query/list', params)
}

/**
 * @desc 行为评分 - 贷后雷达图
 * @method GET
 * @param {
 * // merNo:商户号 
 * // type:类型 0:当期 1:上期 默认0
 * } params 
 */
export const radar = params => {
	return request.get('/behaviorScore/radar', params)
}

/**
 * @desc 行为评分 - FICO分详情
 * @method GET
 * @param {
    * // 商户号 
    * } params 
    */
export const details = params => {
	return request.get('/behaviorScore/details', params)
}

/**
 * @desc 行为评分 - 行业对比
 * @method GET
 * @param { } params 
	*/
export const industryComparison = params => {
	return request.get('/behaviorScore/industryComparison', params)
}

/**
 * @desc 行为评分 - 行业对比详情
 * @method GET
 * @param {
	* // 商户号 
	* merNo:merNo
	* type:type
	* } params 
	*/
export const industryDetail = params => {
	return request.get('/behaviorScore/industryDetail', params)
}

/**
 * @desc 行为评分 - 总分行业对比
 * @method GET
 * @param {
	* // 商户号
	* //类型 0:近半年 1:近1年 默认0
	* } params
	*/

export const totalScoreComparison = params => {
	return request.get('/behaviorScore/totalScoreComparison', params)
}
